
import { computed, defineComponent, inject, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";
import { firestore } from "@/config/firebase";
export default defineComponent({
  setup() {
    const { type } = useBreakpoints();
    const emitter: any = inject("emitter");
    const store = useStore();
    const router = useRouter();
    const profileImage = ref("");
    const toggleSidebar = () => {
      emitter.emit("toogleDrawer", true);
    };
    const isLogged = computed(() => {
      return store.getters["user/isLogged"];
    });
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const participantData = computed(() => {
      return store.getters["user/participantData"];
    });
    const getUserProfileImage = async (eventID, participantID) => {
      const userRef = await firestore("events")
        .doc(eventID)
        .collection("participants")
        .doc(participantID)
        .get();
      profileImage.value = userRef.data()?.profileImage;
    };
    const participantPhoto = computed(() => {
      if (participantData.value) {
        getUserProfileImage(eventData.value.id, participantData.value.uid);
        if (profileImage.value) {
          return profileImage.value;
        }
        return require("@/assets/no_profile_image.png");
      }
      return require("@/assets/no_profile_image.png");
    });
    const getEventClass = () => {
      if (eventData.value) {
        if (eventData.value.themeSettings) {
          return {
            "background-color": eventData.value.themeSettings.primaryColor,
            color: eventData.value.themeSettings.contrastColor,
          };
        }
      }
      return {};
    };
    const goTo = (to) => {
      if (typeof to == "string") {
        router.push({
          name: to,
          params: { eventID: eventData.value.id },
        });
      }
    };
    return {
      toggleSidebar,
      eventData,
      getEventClass,
      goTo,
      isLogged,
      participantPhoto,
      participantData,
      type,
    };
  },
});
